import { useContext, useEffect } from 'react'
import { TransitionGroup } from 'react-transition-group'
import { NotificationContext } from 'components/extend/Notification'
import { ee } from 'components/extend/Notification/NotificationEmitter'
import { TransitionTransformRight } from 'components/extend/Transition'
import { Notification } from 'components/ui/Notification'
import { Portal } from 'components/ui/Portal'

export const Notifications = () => {
  const { items, handleAdd, handleRemove } = useContext(NotificationContext)

  useEffect(() => ee.on(handleAdd), [handleAdd])

  return (
    <Portal>
      <div
        className="z-notice"
        style={{
          position: 'fixed',
          right: 20,
          top: 70
        }}
      >
        <TransitionGroup component={null}>
          {items.map((item) => (
            <TransitionTransformRight key={item.id}>
              <div>
                <Notification notification={item} onRemove={handleRemove} />
              </div>
            </TransitionTransformRight>
          ))}
        </TransitionGroup>
      </div>
    </Portal>
  )
}
